export default __webpack_public_path__ + "static/media/review.ec295280.svg";